import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { ShieldCheck } from "lucide-react";

const STORAGE_KEY = "bazaar_buyer_terms_seen";

// One-time notice shown the first time a Knight proceeds to checkout on the Bazaar — same
// localStorage-per-user pattern as KfPostPolicyModal/MerchantOnboardingModal's rules step.
export function BuyerTermsModal({ open, onOpenChange, userId, onContinue }) {
  const [dontShowAgain, setDontShowAgain] = useState(true);

  const continueToCheckout = () => {
    if (dontShowAgain) {
      const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!seen.includes(userId)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, userId]));
    }
    onOpenChange(false);
    onContinue();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#322216] border-white/10 text-[#f1e0c5]" data-testid="buyer-terms-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-[#D4AF37]" /> Before You Check Out
          </DialogTitle>
          <DialogDescription className="sr-only">Bazaar buyer terms</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-[#f1e0c5]/70 leading-relaxed">
          All sales are under sales conditions of the individual merchant's return policies. All
          sales made have no connection with Call to Arms or Why not? LTD and all proceeds go to
          the merchant. We will never charge you or the sellers extra fees, please report anyone
          trying to charge fees in our name. Enjoy and stay safe.
        </p>
        <label className="flex items-center gap-2 text-xs cursor-pointer">
          <Checkbox data-testid="buyer-terms-dont-show-checkbox" checked={dontShowAgain} onCheckedChange={setDontShowAgain} />
          Don't show this again
        </label>
        <Button data-testid="buyer-terms-continue-button" onClick={continueToCheckout} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-xs">
          I Understand, Proceed to Checkout
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export function hasSeenBuyerTerms(userId) {
  const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  return seen.includes(userId);
}
